export const SUBSCRIPTION_PLAN_LIST = "SUBSCRIPTION_PLAN_LIST";
export const SUBSCRIPTION_PLAN_DETAILS = "SUBSCRIPTION_PLAN_DETAILS";
export const SUBSCRIPTION_PLAN_UPDATE = "SUBSCRIPTION_PLAN_UPDATE";
